<mat-card class="form-card">
    <mat-card-header class="custom-card-header">
        <mat-card-title class="custom-card-title">{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div mat-dialog-content>
            <div class="message-container">
                <span> {{data.message}}</span>
            </div>
        </div>
        <div mat-dialog-actions align="end">
            <button class="height-40 mlr-10" mat-raised-button color="primary" type="button"
                (click)="handleAction('CANCEL')">Cancel</button>
            <button class="height-40" mat-raised-button color="primary" mat-primary
                (click)="handleAction('OK')">Delete</button>            
        </div>
    </mat-card-content>
</mat-card>